function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#000;}.cls-2{fill:#4cb75b;}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "\n        Kenai-bot-logo\n    ");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M150,187.11a57.92,57.92,0,0,1-39.62-15.2,7.24,7.24,0,0,1,0-10.89,9.62,9.62,0,0,1,12.78,0,40,40,0,0,0,53.68,0,9.62,9.62,0,0,1,12.78,0,7.24,7.24,0,0,1,0,10.89A57.93,57.93,0,0,1,150,187.11Z",
  className: "cls-1"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M99.27,133.55C92,133.55,86,128.19,86,121.61S92,109.67,99.27,109.67,112.5,115,112.5,121.61,106.57,133.55,99.27,133.55Z",
  className: "cls-1"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M200.73,133.55c-7.3,0-13.23-5.36-13.23-11.94s5.93-11.94,13.23-11.94S214,115,214,121.61,208,133.55,200.73,133.55Z",
  className: "cls-1"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M259.06,42.61C230.36,15.41,191.34,0,150,0S69.64,15.41,40.94,42.61c-7.3,7.29-4.89,8.28,7.14,1.54h0C77.3,28.91,112.85,20.64,150,20.64s72.7,8.27,101.91,23.51h0C264,50.89,266.36,49.9,259.06,42.61Z",
  className: "cls-1"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M299.59,121.2c-.14-.5-.27-1-.43-1.48s-.21-.75-.35-1.17c-6.44-19.74-21.1-37.47-42.87-51.69C227.44,48.26,189.82,38,150,38S72.56,48.26,44.06,66.86c-21.77,14.22-36.43,32-42.87,51.69-.14.42-.24.78-.35,1.17s-.29,1-.43,1.48c-1.4,5.73.67,7.38,8,7.38H21.75c7.12,0,7.68-.9,12.61-10.31l1.33-2.54C53.34,86.52,99.71,66,150,66s96.66,20.56,114.31,49.77l1.33,2.54c4.93,9.41,5.49,10.31,12.61,10.31h13.38C298.92,128.58,301,126.93,299.59,121.2Z",
  className: "cls-2"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M40.94,240.51c28.7,27.2,67.72,42.61,109.06,42.61s80.36-15.41,109.06-42.61c7.3-7.28,4.89-8.28-7.14-1.53h0C222.7,254.21,187.15,262.49,150,262.49S77.3,254.21,48.09,239h0C36.05,232.23,33.64,233.23,40.94,240.51Z",
  className: "cls-1"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M.41,161.93c.14.49.27,1,.43,1.47s.21.76.35,1.18c6.44,19.74,21.1,37.47,42.87,51.68,28.5,18.6,66.12,28.84,105.94,28.84s77.44-10.24,105.94-28.84c21.77-14.21,36.43-31.94,42.87-51.68.14-.42.24-.79.35-1.18s.29-1,.43-1.47c1.4-5.73-.67-7.39-8-7.39H278.25c-7.12,0-7.68.91-12.61,10.32l-1.33,2.54c-17.65,29.21-64,49.76-114.31,49.76S53.34,196.61,35.69,167.4l-1.33-2.54c-4.93-9.41-5.49-10.32-12.61-10.32H8.37C1.08,154.54-1,156.2.41,161.93Z",
  className: "cls-2"
});

var SvgIconKenaiBot = function SvgIconKenaiBot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 300 283.12",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconKenaiBot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-kenai-bot.81c6bfc5.svg";
export { ForwardRef as ReactComponent };